import {createBrowserRouter} from 'react-router-dom'
import authroutes from './authRoutes'
import myPageRoutes from './myPageRoutes'
import basicRoutes from './basicRoutes'

export default createBrowserRouter([authroutes, myPageRoutes, basicRoutes])
